import { spaceCadet } from '@cogneed/react-utils';
import { Box, alpha, styled } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,

  '&.collapse': {
    backgroundColor: 'white',
    borderRadius: 4,
    padding: 0,
    border: `1px solid ${spaceCadet[100]}`,
    gap: 0,
    margin: '0px -12px',

    '& .commands-button': {
      padding: 8,
      color: spaceCadet[400],
      display: 'flex',
      gap: 4,
      justifyContent: 'flex-start',
      '&:hover': {
        backgroundColor: spaceCadet[100],
      },
      '& svg': {
        color: 'inherit',
        fontSize: 16,
        transform: 'rotate(-90deg)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shortest,
        }),
      },
    },

    '& .MuiCollapse-wrapperInner': {
      padding: '8px 10px',
    },

    '&.expanded': {
      '& .commands-button': {
        backgroundColor: alpha(spaceCadet[300], 0.5),
        '&:hover': {
          '&:hover': {
            backgroundColor: alpha(spaceCadet[300], 0.75),
          },
        },
        '& svg': {
          transform: 'rotate(0deg)',
        },
      },
    },
  },
}));

export default StyledBox;
